module.exports = __webpack_public_path__ + "d03365e612f264f8f52ebc2740448cba.svg";